"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  DeviceAttestation: () => DeviceAttestation
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var DeviceAttestation = Object.freeze({
  getAvailability: function getAvailability() {
    return {
      appAttest: false,
      deviceCheck: false
    };
  },
  generateKey: function generateKey() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("DeviceAttestation.generateKey"));
  },
  attestKey: function attestKey(_keyId, _clientDataHashBase64) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("DeviceAttestation.attestKey"));
  },
  generateAssertion: function generateAssertion(_keyId, _clientDataHashBase64) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("DeviceAttestation.generateAssertion"));
  },
  generateDeviceToken: function generateDeviceToken() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("DeviceAttestation.generateDeviceToken"));
  }
});
//# sourceMappingURL=unavailable.js.map
